import React from "react";
import "./Footer.css";
import './Cloud.jsx'
import Cloud from "./Cloud.jsx";

export default function Footer() {
    return (
        <>
            <section id="footer">
                <div id="footer-container">
                    {/* <div className="footer-atas">
                        <img src="/galaxy-night-landscape.jpg" alt="" />

                        <div className="footer-atas-cloud">
                            <Cloud/>
                        </div>
                    </div> */}

                    <div className="footer-bawah">
                        <div className="footer-bawah-logo">
                            <img src="/logo/logo-only-white.png" alt="" />
                        </div>

                        <div className="footer-bawah-text">
                            <p> © 2023 Owen Marscel </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
